var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSyncCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 14.21 3.91 16.2 5.36 17.64L3.85 19.15C3.54 19.46 3.76 20 4.21 20H8.5C8.78 20 9 19.78 9 19.5V15.21C9 14.76 8.46 14.54 8.15 14.86L6.76 16.25C5.68 15.15 5 13.66 5 12C5 9.61 6.4 7.54 8.43 6.58C8.77 6.42 9 6.11 9 5.74V5.55C9 4.87 8.29 4.44 7.68 4.73C4.92 5.99 3 8.77 3 12ZM11 17H13V15H11V17ZM19.79 4H15.5C15.22 4 15 4.22 15 4.5V8.79C15 9.24 15.54 9.46 15.85 9.14L17.24 7.75C18.32 8.85 19 10.34 19 12C19 14.39 17.6 16.46 15.57 17.42C15.23 17.58 15 17.89 15 18.26V18.44C15 19.12 15.71 19.55 16.32 19.26C19.08 18.01 21 15.23 21 12C21 9.79 20.09 7.8 18.64 6.36L20.15 4.85C20.46 4.54 20.24 4 19.79 4ZM12 13C12.55 13 13 12.55 13 12V8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8V12C11 12.55 11.45 13 12 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSyncCircle);
export default __webpack_public_path__ + "static/media/error-sync-circle.bfceac3ed6b0b1d28358cf685f4652ff.svg";
export { ForwardRef as ReactComponent };